const ContactIcon = ({width, height, color}) => {
  return (
    <svg
      width={width ? width: "27"}
      height={height ? height : "26"}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 11.5C12.0897 11.5 10.7481 10.96 9.76749 10.0157C8.78882 9.07329 8.25 7.80742 8.25 6.5C8.25 5.19257 8.78882 3.92671 9.76749 2.98429C10.7481 2.04001 12.0897 1.5 13.5 1.5C14.9103 1.5 16.2519 2.04001 17.2325 2.98429C18.2112 3.92671 18.75 5.19258 18.75 6.5C18.75 7.80742 18.2112 9.07329 17.2325 10.0157C16.2519 10.96 14.9103 11.5 13.5 11.5ZM1.5 23.4C1.5 21.0461 2.10835 19.5527 3.06631 18.6308C4.03499 17.6986 5.62045 17.1 8.1054 17.1H18.9C21.3827 17.1 22.9667 17.6984 23.9345 18.6305C24.8919 19.5524 25.5 21.0459 25.5 23.4C25.5 24.0202 25.3419 24.2139 25.2844 24.2694C25.2163 24.3349 24.9821 24.5 24.3 24.5H2.7C2.01785 24.5 1.78371 24.3349 1.71563 24.2694C1.65808 24.2139 1.5 24.0202 1.5 23.4Z"
        stroke={color ? color:"#FF6600"}
        strokeWidth="3"
      />
    </svg>
  );
};
export default ContactIcon; 